export enum SupplierType{
    Agent='Agent',
    Farmer='Farmer',
    Broker='Broker'

}